__webpack_require__.p = "https://assets-01.periodica.press/928c849-21865527788/";